import React from 'react';
import { LockIcon, Twitter, Linkedin, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-darker border-t border-brand-border pt-16 pb-8" data-id="element-62">
      <div className="container mx-auto px-6" data-id="element-63">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-64">
          <div className="col-span-1 md:col-span-2" data-id="element-65">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-66">
              <div className="flex items-center justify-center w-8 h-8 rounded-md bg-brand-dark border border-brand-border" data-id="element-67">
                <LockIcon className="w-4 h-4 text-brand-steel" data-id="element-68" />
              </div>
              <span className="font-mono font-bold text-lg tracking-tight text-white" data-id="element-69">
                EPIC<span className="text-brand-steel" data-id="element-70">DROP</span>
              </span>
            </a>
            <p className="text-slate-400 text-sm max-w-sm mb-6 leading-relaxed" data-id="element-71">
              Military-grade proactive cybersecurity for enterprises. We seal
              the perimeter before the breach occurs.
            </p>
            <div className="flex items-center gap-4 text-slate-400" data-id="element-72">
              <a href="#" className="hover:text-brand-steel transition-colors" data-id="element-73">
                <Twitter className="w-5 h-5" data-id="element-74" />
              </a>
              <a href="#" className="hover:text-brand-steel transition-colors" data-id="element-75">
                <Linkedin className="w-5 h-5" data-id="element-76" />
              </a>
            </div>
          </div>

          <div data-id="element-77">
            <h4 className="font-mono font-bold text-white mb-6 uppercase tracking-wider text-sm" data-id="element-78">
              Solutions
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="hover:text-brand-steel transition-colors" data-id="element-81">
                  Bastion Shield
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-brand-steel transition-colors" data-id="element-83">
                  Cipher Veil
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-brand-steel transition-colors" data-id="element-85">
                  Sentinel Mesh
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-brand-steel transition-colors" data-id="element-87">
                  Aegis Pulse
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-88">
            <h4 className="font-mono font-bold text-white mb-6 uppercase tracking-wider text-sm" data-id="element-89">
              Headquarters
            </h4>
            <div className="flex items-start gap-3 text-sm text-slate-400" data-id="element-90">
              <MapPin className="w-5 h-5 text-brand-steel shrink-0 mt-0.5" data-id="element-91" />
              <p data-id="element-92">
                Limassol,
                <br data-id="element-93" />
                Cyprus
                <br data-id="element-94" />
                <span className="text-xs text-brand-cyan mt-2 block" data-id="element-95">
                  Secure Facility
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-brand-border flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-96">
          <p className="text-xs font-mono text-slate-500" data-id="element-97">
            © 2026 Epicdrop. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs font-mono text-slate-500" data-id="element-98">
            <a href="#" className="hover:text-white transition-colors" data-id="element-99">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-100">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-101">
              Security Disclosures
            </a>
          </div>
        </div>
      </div>
    </footer>;
}